import { Box, CircularProgress, useMediaQuery, useTheme } from "@mui/material";
import dayjs, { Dayjs } from "dayjs";
import { useState } from "react";
import { useParams } from "react-router";

import useGetCheckoutSession from "lib/hooks/queries/useGetCheckoutSession";
import { checkoutStyles as styles } from "styles/Checkout/checkout.styles";
import AvailabilityCheckout from "./Checkout/AvailabilityCheckout";
import FarehaborCheckout from "./Checkout/FareharborCheckout";

import "react-responsive-carousel/lib/styles/carousel.min.css";

export default function Checkout() {
  const theme = useTheme();
  const { id } = useParams();
  const isWideScreen = useMediaQuery(theme.breakpoints.up(680));

  // by default, the endpoint should return the availabilities
  // for the month the referral is created for.
  // only set the startTime and endTime when the user changes the month.
  const [startTime, setStartTime] = useState<string>();
  const [endTime, setEndTime] = useState<string>();
  const {
    data: referral,
    isLoading,
    isFetching,
  } = useGetCheckoutSession({
    id,
    startTime,
    endTime,
  });
  const [addInfo, setAddInfo] = useState("");

  const handleMonthChange = (date: Dayjs) => {
    setStartTime(date.startOf("month").toISOString());
    setEndTime(date.endOf("month").toISOString());
  };

  if (isLoading || !referral) {
    return (
      <Box sx={styles.mainContainer()}>
        <Box sx={styles.loaderContainer}>
          <CircularProgress />
        </Box>
      </Box>
    );
  }

  return (
    <Box sx={styles.mainContainer()}>
      <Box sx={styles.contentBox(isWideScreen)}>
        {referral.referral_type === 1 && (
          <AvailabilityCheckout
            referral={referral}
            comment={addInfo}
            setComment={setAddInfo}
            onMonthChange={handleMonthChange}
            isLoadingAvailabilities={isFetching}
          />
        )}
        {referral.referral_type === 4 && (
          <FarehaborCheckout referral={referral} />
        )}
      </Box>
    </Box>
  );
}
